// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  API_URL: 'https://api.take-thegoodfood.de/api/', // 'http://localhost:8000/api/', //
  BASE_URL: 'https://api.take-thegoodfood.de', // 'http://localhost:8000',//
  DEFAULT_LANG: 'de',
  APP_VERSION: '0.3', // change app version to force clear cache
  GOOGLE_COUNTRIES: ["de"], // for google address
  GOOGLE_LOGIN_WEB_CLIENT_ID: '389066575488-7bh2o6kjh9hu98a3kvrk02jrbsq2qhb0.apps.googleusercontent.com',
  FACEBOOK_LOGIN_APP_ID: '1502057223571846',
  // theme configuration
  DEFAULT_PRIMARY_COLOR: '#000000',
  DEFAULT_PRIMARY_TEXT_COLOR: '#000000'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
